import { atom } from "jotai";

export const showSidebarStoreInitialState: boolean = false;

export const ShowSidebarStore = atom(showSidebarStoreInitialState);
